import React from 'react'
export default function Block({ className, style }) {
  return (
    <svg className={className} width="1em" height="1em" style={{ verticalAlign: '-0.125em', ...style }} viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.8"
      strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <path d="M4.929 4.929 19.07 19.071" />
    </svg>
  )
}
